import { PhoneNumberSchema, yup } from '@guiker/shared-framework'

export const updateUserSchema = yup.object({
  proxyEmailAddress: yup.string().email().required(),
  emailAddress: yup.string().email().required(),
  firstName: yup.string().required(),
  lastName: yup.string().nullable(),
  phone: PhoneNumberSchema(false),
})
